/**
 * Feature flags for Insight Hub
 *
 * Controls which features are enabled in the application.
 * Set via environment variables (REACT_APP_FEATURE_*).
 */

export const features = {
  /**
   * Enable billing and subscription features
   * - Shows pricing plans on landing page
   * - Enables upgrade prompts for plan limits
   * - Shows billing page in settings
   *
   * Set REACT_APP_FEATURE_BILLING=true in .env to enable
   */
  billing: process.env.REACT_APP_FEATURE_BILLING === 'true',

  /**
   * Enable card-based payments (Stripe checkout + customer portal).
   *
   * OFF in early access: Single/Team are free and Business is invoiced
   * manually, so NO card provider is wired up. With this off, BillingPage
   * hides the Stripe checkout/portal paths and offers the early-access
   * actions instead (free Team upgrade, request Business). Turn on only once
   * a payment provider is live (see payment-early-access plan, §7).
   *
   * Set REACT_APP_FEATURE_CARD_PAYMENTS=true to enable.
   */
  cardPayments: process.env.REACT_APP_FEATURE_CARD_PAYMENTS === 'true',

  /**
   * Enable AI-generated recommended actions on dashboard.
   * Analyzes product facts and surfaces patterns, themes and priorities.
   */
  recommendedActions: true,
} as const;

/**
 * Helper to check if a feature is enabled
 */
export const isFeatureEnabled = (feature: keyof typeof features): boolean => {
  return features[feature];
};
